<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <br />
  <a-card title="Prontuário CSIPM">
    <div class="row">
      <label>Consultar Milítar</label>
      <div class="col-md-6 d-flex justify-content-left">
        <a-tooltip placement="top" title="Informe o nome, CPF ou RG Militar do Beneficiário" arrow-point-at-center>
          <a-auto-complete v-model:value="responseDadosMilitar.nome" class="form-control" :disabled="encontrado" @search="pesquisarDadosMilitarPeloNomeOuRg">
            <template v-slot:dataSource>
              <a-select-option v-for="item in dataPacientes" :key="item.nome" @click="onSelect(item)"> {{ item.cpf }} - {{ item.nome }} {{ item.rgMilitar }} </a-select-option>
            </template>
          </a-auto-complete>
        </a-tooltip>
        <a-tooltip placement="top" title="Limpar Consulta" arrow-point-at-center>
          <button @click="limpar()" style="margin-left: 4px" class="btn btn-icon-button" type="button"><i class="fa fa-eraser"></i></button>
        </a-tooltip>
      </div>
    </div>
  </a-card>
  <br />
  <a-card v-if="encontrado">
    <div class="row">
      <PageDadosMilitar v-model:dadosMilitar="responseDadosMilitar" />
    </div>
  </a-card>
</template>

<script>
import PageDadosMilitar from '@/components/pages/PageDadosMilitar';
import { getPaciente } from '@/components/service/pacienteService';
export default {
  name: 'PageProntuarioCSIPM',
  components: {
    PageDadosMilitar,
  },

  setup() {
    return {};
  },
  data() {
    return {
      encontrado: false,
      dataPacientes: [],
      responseDadosMilitar: {},
      PageDadosMilitar: PageDadosMilitar,
    };
  },

  methods: {
    async pesquisarDadosMilitarPeloNomeOuRg(value) {
      if (value.length > 3) {
        await getPaciente({ any: value }).then((r) => {
          this.dataPacientes = r.data.pacientes;
        });
      } else {
        this.dataPacientes = [];
      }
    },
    limpar() {
      this.responseDadosMilitar = {};
      this.dataPacientes = [];
      this.encontrado = false;
    },

    onSelect(value) {
      this.responseDadosMilitar = { ...value };
      setTimeout(() => {
        this.encontrado = true;
      }, 1);
    },
  },
  created() {},
};
</script>

<style></style>
